export default __webpack_public_path__ + "static/media/footer.947b417e.png";